import {Environment} from "./environment.model";

export const environment: Environment = {
    environment: "dev",
    azure: {
        appId: "69eab5ba-decb-43c0-8502-8f4976eb0a97",
        tenantId: "6541ac25-e401-4860-9fca-e01fab1b6514",
    },
    apiBasePath: "https://dmp-dev-api.gourmet.at",
};
